import 'typeface-poppins';
import AppRouter from './router/AppRouter';
import './App.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';




function App() {
  return (
    <div>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        limit={3}
        enableMultiContainer={false}
      />
      <AppRouter className='App'/>
    </div>
  );
}

export default App;
